import { render, staticRenderFns } from "./OrgImportRecshareDlg.vue?vue&type=template&id=2a4d2344&scoped=true"
import script from "./OrgImportRecshareDlg.vue?vue&type=script&lang=js"
export * from "./OrgImportRecshareDlg.vue?vue&type=script&lang=js"
import style0 from "./OrgImportRecshareDlg.vue?vue&type=style&index=0&id=2a4d2344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4d2344",
  null
  
)

export default component.exports